import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../helper/apiCall';
import ENDPOINTS from '../../constants/endpoints';

export const fetchParents = createAsyncThunk(
  'studentParents/fetchParents',
  async ({ branchId, placeId, pageIndex = 0, pageSize = 10 }, thunkAPI) => {
    try {
      const params = new URLSearchParams();
      params.append('pageIndex', pageIndex);
      params.append('pageSize', pageSize);
      params.append('branchId', branchId);
      if (placeId) params.append('placeId', placeId);
      const response = await client.get(`${ENDPOINTS.STUDENT_PARENTS.GET_LIST}?${params.toString()}`, {
        token: thunkAPI.getState().auth.token,
      });
      return response.data; // array veya {items, ...}
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createParentPassword = createAsyncThunk(
  'studentParents/createPassword',
  async ({ parentId, branchId }, thunkAPI) => {
    try {
      const url = ENDPOINTS.STUDENT_PARENTS.CREATE_PASSWORD.replace(':parentId', parentId);
      const response = await client.post(`${url}?branchId=${branchId}`, {}, {
        token: thunkAPI.getState().auth.token,
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchPreRegistrations = createAsyncThunk(
  'studentParents/fetchPreRegistrations',
  async (arg, thunkAPI) => {
    try {
      const { branchId, placeId } = arg || {};
      const params = new URLSearchParams();
      if (branchId) params.append('branchId', branchId);
      if (placeId) params.append('placeId', placeId);
      const query = params.toString() ? `?${params.toString()}` : '';
      const response = await client.get(`${ENDPOINTS.PRE_REGISTRATIONS.GET_LIST}${query}`, {
        token: thunkAPI.getState().auth.token,
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deletePreRegistration = createAsyncThunk(
  'studentParents/deletePreRegistration',
  async ({ id }, thunkAPI) => {
    try {
      const response = await client.delete(`${ENDPOINTS.PRE_REGISTRATIONS.DELETE.replace(':id', id)}`, {}, {
        token: thunkAPI.getState().auth.token,
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updatePreRegistration = createAsyncThunk(
  'studentParents/updatePreRegistration',
  async (data, thunkAPI) => {
    try {
      const response = await client.put(`${ENDPOINTS.PRE_REGISTRATIONS.UPDATE}`, data, {
        token: thunkAPI.getState().auth.token,
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);


const studentParentsSlice = createSlice({
  name: 'studentParents',
  initialState: {
    loading: false,
    error: null,
    items: [],
    pagination: { index: 0, size: 10, count: 0, pages: 0, hasPrevious: false, hasNext: false },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchParents.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchParents.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload;
        if (Array.isArray(payload)) {
          state.items = payload;
          state.pagination = {
            index: 0,
            size: payload.length,
            count: payload.length,
            pages: 1,
            hasPrevious: false,
            hasNext: false,
          };
        } else {
          const items = payload?.items || [];
          state.items = items;
          state.pagination = {
            index: payload?.index || 0,
            size: payload?.size || items.length,
            count: payload?.count || items.length,
            pages: payload?.pages || 1,
            hasPrevious: payload?.hasPrevious || false,
            hasNext: payload?.hasNext || false,
          };
        }
      })
      .addCase(fetchParents.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(createParentPassword.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(createParentPassword.fulfilled, (state) => { state.loading = false; })
      .addCase(createParentPassword.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(fetchPreRegistrations.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchPreRegistrations.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchPreRegistrations.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(deletePreRegistration.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(deletePreRegistration.fulfilled, (state) => { state.loading = false; })
      .addCase(deletePreRegistration.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(updatePreRegistration.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(updatePreRegistration.fulfilled, (state) => { state.loading = false; })
      .addCase(updatePreRegistration.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
  }
});

export default studentParentsSlice.reducer;
